<template>
    <div>
        <title-component></title-component>
        <div class="row">
            <div class="col home-card jumbotron-slide-show">
                <jumbotron-component></jumbotron-component>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 home-card">
                <home-title-component :title="$t('home.profile.title')"></home-title-component>
                <home-content-component :content="$t('home.profile.content')"></home-content-component>
                <home-link-component :path="homeConfig[0].path"></home-link-component>
            </div>
            <div class="col-12 col-sm-6 home-card">
                <home-title-component :title="$t('home.guardian.title')"></home-title-component>
                <home-content-component :content="$t('home.guardian.content')"></home-content-component>
                <home-link-component :path="homeConfig[2].path"></home-link-component>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 home-card">
                <home-title-component :title="$t('home.photos.title')"></home-title-component>
                <home-content-component :content="$t('home.photos.content')"></home-content-component>
                <home-link-component :path="homeConfig[4].path"></home-link-component>
            </div>
            <div class="col-12 col-sm-6 home-card">
                <home-title-component :title="$t('home.documents.title')"></home-title-component>
                <home-content-component :content="$t('home.documents.content')"></home-content-component>
                <home-link-component :path="homeConfig[5].path"></home-link-component>
            </div>
            <div class="col-12 col-sm-6">
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 home-card">
                <home-title-component :title="$t('home.misc.title')"></home-title-component>
                <home-content-component :content="$t('home.misc.content')"></home-content-component>
                <home-link-component :path="homeConfig[3].path"></home-link-component>
            </div>
            <div class="col-12 col-sm-6 home-card">
                <home-title-component :title="$t('home.pets.title')"></home-title-component>
                <home-content-component :content="$t('home.pets.content')"></home-content-component>
                <home-link-component :path="homeConfig[6].path"></home-link-component>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6 home-card">
                <home-title-component :title="$t('home.funeral.title')"></home-title-component>
                <home-content-component :content="$t('home.funeral.content')"></home-content-component>
                <home-link-component :path="homeConfig[1].path"></home-link-component>
            </div>
            <div class="col-12 col-sm-6">
            </div>
        </div>
    </div>
</template>

<script>
    import siteconfig from '../assets/data/siteconfig'
    import TitleComponent from './shared/TitleComponent'
    import HomeTitleComponent from './home/HomeTitleComponent'
    import HomeContentComponent from './home/HomeContentComponent'
    import HomeLinkComponent from './home/HomeLinkComponent'
    import JumbotronComponent from '../components/JumbotronComponent'
    import i18n from '../assets/i18n/lang'

    export default {
        name: 'Home',
        metaInfo () { return { title: i18n.t('home.meta') } },
        components: {
            HomeLinkComponent,
            HomeContentComponent,
            'title-component': TitleComponent,
            'home-title-component': HomeTitleComponent,
            'home-content-component': HomeContentComponent,
            'home-link-component': HomeLinkComponent,
            'jumbotron-component': JumbotronComponent
        },
        computed: {
            homeConfig: function () {
                return siteconfig.home.sort(this.compare)
            }
        },
        methods: {
            compare: function (a, b) {
                if (a.position < b.position) return -1
                if (a.position > b.position) return 1
                return 0
            }
        }
    }
</script>

<style lang="scss" scoped>

    .home-card {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 52px;
    }

    .jumbotron-slide-show {
        padding-top: 0px;
    }

    @media (min-width: 768px) {
        .home-card {
            padding-left: 80px;
            padding-right: 80px;
            padding-top: 52px;
        }

        .jumbotron-slide-show {
            padding-top: 0px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/HomeComponent.vue